import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
} from "react-native";
import { Controller } from "react-hook-form";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import RentPeriodSelector from "./rentPeriodSelector";
import TenantRoleCards from "./TenantRoleCards";

const TenantDetails = ({
  control,
  watch,
  setValue,
  errors,
  openFlow,
  payload,
  setShowOrgPopup, 
  reset  // ← POPUP CONTROL FROM PARENT
}) => {
  const isOrgTenant = watch("is_organizational_tenant");
  const [address, setAddress] = useState("");

  // Prefill from API
  useEffect(() => {
    if (payload) {
      const tenantPayload =  payload 
  console.log("tenantPayload",tenantPayload)
      const prefill = {
        is_organizational_tenant: tenantPayload.is_organizational_tenant || "",
        is_relative_person: tenantPayload.is_relative_person || "",
        agreement: tenantPayload.agreement || "",
        contactAddress: tenantPayload.contactAddress || "",
      };
      setAddress(prefill.contactAddress);
      reset(prefill);
    }
  }, [openFlow, payload]);

  useEffect(() => {
    setValue("contactAddress", address);
  }, [address]);

  return (
    <ScrollView style={styles.container} contentContainerStyle={{ paddingBottom: 40 }}>

      {/* 1️⃣ ORGANIZATIONAL TENANT */}
      <Controller
        control={control}
        name="is_organizational_tenant"
        render={({ field }) => (
          <RentPeriodSelector
            heading="Is any tenant associated with this deposit an organization?"
            items={[
              { value: "YES", label: "Yes" },
              { value: "NO", label: "No" },
            ]}
            selected={field.value}
            onSelection={(val) => {
              field.onChange(val);
              if (val === "YES") {
                setShowOrgPopup(true); // ← POPUP WILL OPEN
              }
            }}
            error={errors.is_organizational_tenant?.message}
          />
        )}
      />

      {/* 2️⃣ TENANT DETAILS ONLY IF NO */}
      {isOrgTenant === "NO" && (
        <>
          {/* Tenant Cards */}
          <TenantRoleCards
            tenants={openFlow?.tenants || []}
            openflow_id={openFlow?.openflow_id}
            address={address}
            onAddressChange={setAddress}
          />

          {/* 3️⃣ Add relevant person selection */}
          <Controller
            control={control}
            name="is_relative_person"
            render={({ field }) => (
              <RentPeriodSelector
                heading="Add relevant person?"
                items={[
                  { value: "YES", label: "Yes" },
                  { value: "NO", label: "No" },
                ]}
                selected={field.value}
                onSelection={field.onChange}
                error={errors.is_relative_person?.message}
              />
            )}
          />

          {/* Info box */}
          <View style={styles.infoBox}>
            <MaterialCommunityIcons name="information" size={20} color="#2CA7C2" />
            <Text style={styles.infoText}>
              Please note you are agreeing to the Terms and Conditions of the Tenancy Deposit Scheme.
            </Text>
          </View>

          {/* Terms link */}
          <TouchableOpacity
            style={styles.termsButton}
            onPress={() => {
              window.open("https://www.tenancydepositscheme.com/terms-conditions/", "_blank");
            }}
          >
            <Text style={styles.termsText}>TERMS AND CONDITIONS</Text>
          </TouchableOpacity>

          {/* 4️⃣ Agreement */}
          <Text style={styles.agreeLabel}>Do you agree with the above statement?</Text>

          <Controller
            control={control}
            name="agreement"
            render={({ field }) => (
              <View style={styles.radioRow}>
                {/* Agree */}
                <TouchableOpacity
                  style={[
                    styles.radioOption,
                    field.value === "agree" && styles.activeOption,
                  ]}
                  onPress={() => field.onChange("agree")}
                >
                  <MaterialCommunityIcons
                    name={field.value === "agree" ? "circle-slice-8" : "circle-outline"}
                    size={22}
                    color={field.value === "agree" ? "#7c4dff" : "#999"}
                  />
                  <Text>I have read and agree</Text>
                </TouchableOpacity>

                {/* Disagree */}
                <TouchableOpacity
                  style={[
                    styles.radioOption,
                    field.value === "disagree" && styles.activeOption,
                  ]}
                  onPress={() => field.onChange("disagree")}
                >
                  <MaterialCommunityIcons
                    name={
                      field.value === "disagree"
                        ? "circle-slice-8"
                        : "circle-outline"
                    }
                    size={22}
                    color={field.value === "disagree" ? "#7c4dff" : "#999"}
                  />
                  <Text>I don’t agree</Text>
                </TouchableOpacity>
              </View>
            )}
          />

          {errors.agreement && (
            <Text style={styles.errorMessage}>{errors.agreement.message}</Text>
          )}
        </>
      )}

    </ScrollView>
  );
};

export default TenantDetails;

const styles = StyleSheet.create({
  container: { padding: 16 },

  infoBox: {
    backgroundColor: "#e5f7ff",
    padding: 14,
    borderRadius: 8,
    marginTop: 25,
    flexDirection: "row",
    gap: 10,
  },
  infoText: { flex: 1, color: "#2CA7C2" },

  termsButton: {
    backgroundColor: "#2CA7C2",
    padding: 12,
    borderRadius: 8,
    marginTop: 10,
    alignItems: "center",
  },
  termsText: { color: "white", fontWeight: "600" },

  agreeLabel: {
    marginTop: 30,
    fontWeight: "600",
    fontSize: 16,
  },

  radioRow: {
    flexDirection: "row",
    gap: 20,
    marginTop: 12,
    flexWrap: "wrap",
  },
  radioOption: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    padding: 10,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#ccc",
  },
  activeOption: {
    backgroundColor: "#f3eaff",
    borderColor: "#7c4dff",
  },

  errorMessage: {
    color: "red",
    marginTop: 6,
  },
});
